import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PlatformResponse } from 'src/app/interfaces/webservices-interface';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';

@Injectable({
  providedIn: 'root'
})
export class RewardsService {

  public customer: CustomerModel;

  constructor(
    public userSessionService: UserSessionService,
    private webservices: WebservicesService,
  ){
    this.userSessionService.getCustomer().subscribe(customer => {
			this.customer = customer;
		});
  }

   callGetSignupOffers(data):Observable<PlatformResponse<any>> {
    let obj: any = {
      clientapp: data.clientapp,
    }
    return this.webservices.get('rewards/get-signup-offers', obj);
   }

   callGetSignupOffer(promoCode):Observable<PlatformResponse<any>> {
    let obj: any = {
        promo_code: promoCode
    }
    return this.webservices.get('rewards/get-signup-offer', obj);
  }


  callGetBonusOffers() {
    let obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSessionService.getSessionToken()
    }

    return this.webservices.get('rewards/get-bonus-offers', obj);
  }

  callGetCustomerCasinoBonusesActiveOptIn() {
    let obj: any = {
        customer_id: this.customer.customerId,
        optin: false,
        session_token: this.userSessionService.getSessionToken()
    }

    return this.webservices.get('rewards/get-customer-casino-bonuses-active', obj);
  }

  callRFBBonusOptIn(data) {
    let obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSessionService.getSessionToken()
    }
    if (data && data.only_active) obj.only_active = true;
    return this.webservices.get('bonus/get-customer-rfb-bonuses', obj);
  }

  callBonusOptIn(bonus_id: string) {
    let obj: any = {
        customer_casino_bonus_id: bonus_id,
        customer_id: this.customer.customerId,
        session_token: this.userSessionService.getSessionToken()
    }

    return this.webservices.post('rewards/bonus-opt-in', obj);
  }

  callRFBBonusForfeit(bonus_id: string) {
    let obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSessionService.getSessionToken(),
        customer_rfb_bonus_id: bonus_id
    }
    
    return this.webservices.post('bonus/rfb-bonus-forfeit', obj);
  }

  getInternalFreeSpins(){
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSessionService.getSessionToken(),
  }
  
  return this.webservices.get('rewards/get-bonus-free-spins', obj);
  }
}
